import Sidebar from '../../organisms/sidebar/sidebar';

/* eslint-disable-next-line */
type SectionContainerWithSidebarProps = {
  children: React.ReactNode | React.ReactNodeArray;
  featuredContents?: React.ReactNode | React.ReactNodeArray;
};

export function ContainerWithSidebar(props: SectionContainerWithSidebarProps) {
  const { children, featuredContents = <Sidebar /> } = props;

  return (
    <div className="relative grid grid-cols-12 h-full w-full max-w-defaultMax mt-12 mx-auto">
      <div className="col-span-12 lg:col-span-9 border-r-[1px] border-headerBackground px-4">
        {children}
      </div>
      <div className="col-span-12 lg:col-span-3 mb-12">{featuredContents}</div>
    </div>
  );
}

export default ContainerWithSidebar;
